import { ICloneable } from '../interfaces/cloneable.interface';
import { DateUtils } from '../utils/date.utils';
import { ObjectUtils } from '../utils/object.utils';

export enum OccurrenceType {
  ObjectOnTheGroundNotInTheSystem = '100000001',
  ObjectInTheSystemNotOnTheGround = '100000002',
  Complaint = '100000003',
  DamagedObject = '100000000',
}

export interface OccurrenceTypeModelLike {
  id: string;
  description: string;
  idSiia: OccurrenceType;
}

// 1	Notificada
// 100000002	Cancelada
// 100000001	Criada
// 100000000	Aceite
// 2	Resolvida

export enum StatusOccurrenceType {
  Created = '100000001',
  Canceled = '100000002',
  Notified = '1',
  Accepted = '100000000',
  Resolved = '2',
}

export enum EEstadoEntidadeNotificada {
  Notified = 1,
  Accepted = 100000001,
  Rejected = 100000002,
  Resolved = 100000004,
  Closed = 2,
  Canceled = 100000003,
}

export interface StatusOccurrenceLike {
  id: string;
  description: string;
  idSiia: StatusOccurrenceType;
}

export interface OccurrenceNoteModelLike {
  id?: string;
  text?: string;
}

export interface OccurrenceAttachmentModelLike {
  id?: string;
  text?: string;
  url?: string;
}

export interface OccurrenceObjectModelLike {
  id?: string;
  type?: string;
  entityId?: string;
  objectRegisterId?: string;
}

export interface OccurrenceModelLike {
  id?: string;
  userId?: string;
  entityId?: string;
  notifiedEntityList?: {
    id: string;
    status: EEstadoEntidadeNotificada;
  }[];
  createdAt?: Date;
  idsic?: string;
  type?: string;
  typeSiia?: OccurrenceType;
  status?: string;
  statusSiia?: StatusOccurrenceType;
  observation?: string;
  geometry?: string;
  notes?: OccurrenceNoteModelLike[];
  attachments?: OccurrenceAttachmentModelLike[];
  objects?: OccurrenceObjectModelLike[];
}

export class OccurrenceModel
  implements OccurrenceModelLike, ICloneable<OccurrenceModel>
{
  id?: string;
  userId?: string;
  entityId?: string;
  notifiedEntityList?: {
    id: string;
    status: EEstadoEntidadeNotificada;
  }[];
  createdAt?: Date;
  idsic?: string;
  type?: string;
  typeSiia?: OccurrenceType;
  status?: string;
  statusSiia?: StatusOccurrenceType;
  observation?: string;
  geometry?: string;
  notes?: OccurrenceNoteModelLike[];
  attachments?: OccurrenceAttachmentModelLike[];
  objects?: OccurrenceObjectModelLike[];

  constructor(item?: Partial<OccurrenceModelLike>) {
    this.id = item?.id;
    this.userId = item?.userId;
    this.entityId = item?.entityId;
    this.notifiedEntityList =
      item?.notifiedEntityList?.map((x) => ObjectUtils.clone(x)) ?? [];
    this.createdAt = DateUtils.parseDateTime(item?.createdAt);
    this.idsic = item?.idsic;
    this.type = item?.type;
    this.typeSiia = item?.typeSiia;
    this.status = item?.status;
    this.statusSiia = item?.statusSiia;
    this.observation = item?.observation;
    this.geometry = item?.geometry;
    this.notes = item?.notes?.map((x) => ObjectUtils.clone(x)) ?? [];
    this.attachments =
      item?.attachments?.map((x) => ObjectUtils.clone(x)) ?? [];
    this.objects = item?.objects?.map((x) => ObjectUtils.clone(x)) ?? [];
  }

  clone() {
    return new OccurrenceModel(this);
  }
}
